import { ProductDoc, ProductInventoryDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { Button } from 'antd';
import { useEffect } from 'react';

import { useInventory } from 'src/redux/hooks/useInventory';

import useSWRProductInventory from 'src/hooks/swr/useSWRProductInventory';

// 중첩된 필드('.'으로 구분된 경우) 처리
const getNestedValue = (obj: any, path: string): any => {
  if (!obj) return '';
  const keys = path.split('.');
  return keys.reduce((o, key) => (o && o[key] !== undefined ? o[key] : ''), obj);
};

interface AgCellInventoryProps extends ICellRendererParams {
  inventoryId: string;
  field: keyof ProductInventoryDoc | string;
  product?: ProductDoc;
}

// 재고명을 조회하여 표시하는 CellRenderer 컴포넌트
const AgCellInventory = (params: AgCellInventoryProps) => {
  const inventoryId = params.inventoryId;
  const { inventory } = useSWRProductInventory(inventoryId);

  const value = (getNestedValue(inventory, params.field) ?? '') as string;
  const { onSetSelectedInventory, onSetSelectedProduct } = useInventory();

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  if (params.field === 'inventoryName') {
    if (params.product) {
      return (
        <Button type='link' onClick={() => onSetSelectedProduct(params.product ?? null)}>
          {value}
        </Button>
      );
    }
    return (
      <Button type='link' onClick={() => onSetSelectedInventory(inventoryId)}>
        {value}
      </Button>
    );
  }

  return <span>{value}</span>;
};

export default AgCellInventory;
